import type { FC } from 'react';

export interface SortOption {
  value: string;
  label: string;
}

interface SortSelectProps {
  value: string;
  onChange: (value: string) => void;
  options: SortOption[];
  label?: string;
}

const SortSelect: FC<SortSelectProps> = ({ value, onChange, options, label = 'Ordenar' }) => (
  <label className="inline-flex items-center gap-2 text-xs text-foreground-500 whitespace-nowrap">
    <span>{label}</span>
    <select value={value} onChange={(event) => onChange(event.target.value)} className="px-3 py-2 bg-background-50 border border-background-200 rounded-lg text-xs text-foreground-700 focus:outline-none focus:border-primary-300">
      {options.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
    </select>
  </label>
);

export default SortSelect;
